// extracted by mini-css-extract-plugin
export var leftAlign = "_2h-2";
export var popper = "_2h-0";
export var subtitle = "_2h-1";